export const COLUMN_WIDTH = 286;
export const MARGIN_BETWEEN_CARDS = 40;
